import { Box, CircularProgress, Typography } from "@mui/material";
import { CGI_RED, CGI_SUCCESS, CGI_WARNING } from "../helpers/enums";

export default function CircularProgressWithLabel({ progressValue }) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        value={progressValue}
        sx={{
          color:
            progressValue < 50
              ? CGI_RED
              : progressValue < 75
              ? CGI_WARNING
              : CGI_SUCCESS,
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ userSelect: "none", fontSize: 12 }}
        >
          {Math.floor(progressValue)}%
        </Typography>
      </Box>
    </Box>
  );
}
